module.exports = __webpack_public_path__ + "static/media/card_amex.3a6cfc5d.svg";